import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BaseComponent} from "../../../../../../../base/components/base.component";
import {EventKey} from "../../../../../../../registry/event.key";
import {IUploadFile} from "../../models/IUploadFile";
import {EventBusService} from "../../../../../../../base/services/eventbus/event-bus.service";
import {Router} from "@angular/router";
import {SubscriptionContainerService} from "../../../../../../../base/services/subscription-container.service";
import {NotifierService} from "../../../../../../../base/services/notifier/notifier.service";
import {FileService} from "../../services/file.service";
import {IImageSlice} from "../../models/file.model";

@Component({
  selector: 'app-image-uploader-v2',
  templateUrl: './image-uploader-v2.component.html',
  styleUrls: ['./image-uploader-v2.component.scss']
})
export class ImageUploaderComponentV2 extends BaseComponent {
  @Input() title: string = 'Upload Images'
  msg: string = ''
  @Input() multiSelect: boolean = false
  uploadFiles: IUploadFile[] = []

  @Input() required: boolean = false
  @Input() images: IImageSlice[] = []
  @Input() uniqueNamespace: string
  @Output() onUploaded: EventEmitter<IImageSlice[]> = new EventEmitter<IImageSlice[]>()

  protected componentName(): string {
    return ImageUploaderComponentV2.name;
  }

  constructor(eventBus: EventBusService,
              router: Router,
              subContainer: SubscriptionContainerService,
              private fileService: FileService,
              private notifier: NotifierService
  ) {
    super(eventBus, router, subContainer)
    this.loading = false
    if (this.uniqueNamespace == null)
      this.uniqueNamespace = this.getUniqueId(4)
  }

  ngOnInit(): void {
    console.log(this.images)
  }

  uploadImages(): void {
    if (this.uploadFiles.length == 0) {
      if (this.required) {
        this.msg = "File not selected"
      } else {
        this.onUploaded.emit(this.images)
      }
      return
    }
    console.log('uploading images..')
    this.loading = true
    let files: File[] = []
    this.uploadFiles.forEach(uf => {
      files.push(uf.file)
    });
    let key = this.componentKey(EventKey.FILES.IMAGE_UPLOAD(this.uniqueNamespace + '-img'))
    this.fileService.uploadImagesV2(key, files)
    // this.progress(30, 'Uploading Images..')
    this.subscribe(
      key,
      null,
      (value, meta) => {
        this.images = <IImageSlice[]>meta.data
        this.loading = false
        this.onUploaded.emit(this.images)
        console.log("Uploaded successfully!")
        console.log(this.images)
      });
  }

  protected onImageSelected(event: any) {
    if (event.target.files && event.target.files[0]) {
      // validate image
      const mimeType = event.target.files[0].type;
      if (mimeType.match(/image\/*/) == null) {
        this.notifier.warning("Unsupported", "Only images are supported.");
        return;
      }

      let uf: IUploadFile = {
        file: event.target.files[0],
        previewUrl: null
      }

      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      let previewUrl: any;
      reader.onload = (e) => { // called once readAsDataURL is completed
        let url = e.target?.result
        if (url !== undefined && url !== null) {
          uf.previewUrl = url
          if (!this.multiSelect) {
            console.log("resetting images")
            this.images = []
            console.log(this.images)
            this.uploadFiles = []
          }
          this.uploadFiles.push(uf);
          this.msg = ''
        }
      }
    }
  }

  protected removeImage(uf: IUploadFile) {
    let index = this.uploadFiles.map(file => file.previewUrl).indexOf(uf.previewUrl)
    this.uploadFiles.splice(index, 1)
  }


  removeExImage(img: IImageSlice) {
    let index = this.images.indexOf(img)
    this.images.splice(index)
  }

  getUniqueId(parts: number): string {
    const stringArr = [];
    for (let i = 0; i < parts; i++) {
      // tslint:disable-next-line:no-bitwise
      const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      stringArr.push(S4);
    }
    return stringArr.join('-');
  }

}
